import { TaxonomyMasterPage } from "@/components/taxonomy-master-page";

export default function Concepts() {
  return (
    <TaxonomyMasterPage
      kind="concept"
      title="Concepts"
      hint="An open list — a question can use a concept not listed here; it's flagged as a new-concept candidate for review instead of rejected."
    />
  );
}
